import { library } from '@fortawesome/fontawesome-svg-core'

import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons/faSpinnerThird'
import { faExclamation } from '@fortawesome/pro-solid-svg-icons/faExclamation'
import { faEdit } from '@fortawesome/pro-solid-svg-icons/faEdit'
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash'
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock'
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons/faPlusCircle'
import { faArrowsAltH } from '@fortawesome/pro-solid-svg-icons/faArrowsAltH'
import { faCompressAlt } from '@fortawesome/pro-solid-svg-icons/faCompressAlt'
import { faBallotCheck } from '@fortawesome/pro-solid-svg-icons/faBallotCheck'

library.add(
  faTimes, faSpinnerThird, faExclamation, faEdit, faTrash, faClock, faPlusCircle, faArrowsAltH, faCompressAlt,
  faBallotCheck
)
